import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";

// 👇 PWA service worker importu
import { registerSW } from "virtual:pwa-register";

// 👇 PWA aktif et
registerSW({
  onOfflineReady() {
    console.log("✅ Offline mod aktif!");
  },
  onNeedRefresh() {
    console.log("🔄 Yeni versiyon mevcut, sayfayı yenile!");
  },
});

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>,
);
